import React from 'react';
import PropTypes from 'prop-types';

const UiNewWindowPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12.474 3h.026a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0V4.744L8.899 7.846a.527.527 0 0 1-.745-.745L11.256 4H9.5a.5.5 0 0 1 0-1h2.974zM6 10h4V8.5a.5.5 0 1 1 1 0v2a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1H6v4z"
    />
  );
};

UiNewWindowPath.propTypes = {
  fill: PropTypes.string,
};

export default UiNewWindowPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-new-window.jsx